<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM7 9.5C6.58579 9.5 6.25 9.83579 6.25 10.25C6.25 10.6642 6.58579 11 7 11C7.41421 11 7.75 10.6642 7.75 10.25C7.75 9.83579 7.41421 9.5 7 9.5ZM7.5 3C7.5 2.72386 7.27614 2.5 7 2.5C6.72386 2.5 6.5 2.72386 6.5 3V8C6.5 8.27614 6.72386 8.5 7 8.5C7.27614 8.5 7.5 8.27614 7.5 8V3Z"
    fill="currentColor" />
</template>
